import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    titleSkeleton: {
      width: 100,
    },
    subTitleSkeleton: {
      width: 200,
    },
    searchSkeleton: {
      width: '100%',
      height: 40,
    },
    skeletonTable: {
      width: '100%',
      height: 200,
    },
    tabsSkeleton: {
      marginRight: 12,
      width: 100,
      height: 40,
    },
  });
